export default "__VITE_ASSET__D5745hqM__"